import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';

const theme = createTheme({
    typography: {
        fontFamily: [
            '"Nunito"',
            'sans-serif',
        ].join(','),
    },
    palette: {
        primary: {
            main: "#B71234",
            light: "#C5415C",
            dark: "#800C24",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "rgb(171, 0, 60)",
            light: "rgb(211, 0, 85)",
            dark: "rgb(141, 0, 60)",
            contrastText: "rgba(0, 0, 0, 0.87)",
        },
        error: {
            main: "#F44336",
            light: "#E57373",
            dark: "#D32F2F",
            contrastText: "#ffffff",
        },
        danger: 'red',
        success: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: "#ffffff",
        },
    },
}, esES);

theme.components = {
    MuiDialog: {
        styleOverrides: {
            paper: {
                borderRadius: '12px',
                [theme.breakpoints.down('sm')]: {
                    borderRadius: 0,
                },
            },
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                margin: 0,
                padding: 0,
            },
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: "16px",
            },
        },
    },
    MuiForm: {
        styleOverrides: {
            root: {
                "& *": {
                    marginTop: "16px",
                },
            },
        },
    },
};

const SinapThemev2 = theme;

export default SinapThemev2;